import {InputBase, InputBaseProps} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';
import {FieldAdapter} from '../field-factory';
import {IMaskInput, IMaskInputProps} from 'react-imask';

export type $MaskedInputAdapterProps = InputBaseProps & {
  onChange?: (value?: string) => void;
} & Omit<IMaskInputProps<HTMLInputElement>, 'onChange' | 'onAccept'>;

export const $MaskedInputAdapter: FC<FieldAdapter<$MaskedInputAdapterProps>> = ({
  inputProps: {onChange, disabled, ...inputProps},
  control,
}) => {
  const {
    field: {onChange: fieldOnChange, ref, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const {readOnly} = useContext(ReadOnlyContext);

  return (
    <InputBase
      error={invalid}
      inputRef={ref}
      disabled={disabled || readOnly}
      component={IMaskInput}
      onAccept={(value) => {
        fieldOnChange(value);
        onChange?.(value);
      }}
      {...fieldProps}
      {...inputProps}
    />
  );
};